// 2017 Topps Star Wars Galactic Files Reborn — authored by hand (2026-09-18,
// collector-requested)
// =============================================================================
// SOURCES: the OFFICIAL Topps checklist PDF + .xls (hosted by GTS Distribution,
// gogts.net) cross-checked against nslists (House of Checklists, which reads
// the printed card codes the PDF omits) and TCDB (sid 135181 + per-insert
// sids). Counts agree three ways on every sub-set: 200 base / 15+9+10+20+10
// inserts / 62 autographs / 9 duals / 8 triples / 1 six-person / 32 medallions
// / 80 sketch artists.
//
// BASE: 200 cards in ten film/series sections with per-section numbering
// (TPM-1..25, AOTC-1..20, ACW-1..21, ROTS-1..18, REB-1..15, ANH-1..29,
// ESB-1..16, ROTJ-1..18, RO-1..8, TFA-1..30) — NOT 1-200. One sub-set because
// the whole run shares one ladder; the section order below is the official
// PDF's. ⚠️ 2018 Galactic Files CONTINUES these per-section numbers (its TPM
// cards start above 25), so never "fix" a 2018 card into this file. Ladder:
// Orange (2 per pack) and Blue (1:2) unnumbered, Green /199, Purple /99
// (hobby), Gold /10 (hobby), Red 1/1 (hobby). Printing plates exist for
// base, every insert and the autographs; CK does not track plates.
// The gray "base" IS the base card. Card backs carry six attribute ratings
// (Force Power etc.) — flavor data, not tracked.
//
// INSERTS: five sets, all with the same Purple /99 / Gold /10 / Red 1/1
// ladder (TCDB SN tags + nslists agree; base versions unnumbered).
//
// AUTOGRAPHS: 62 signers, codes AU-XXX as printed (nslists reads them off
// cards; the official PDF lists signers with no codes). Ladder: Gold /25,
// Red 1/1 (TCDB SN tags). ⚠️ The BASE autographs carry per-signer serial
// numbering that varies card by card — nslists documents observed runs from
// /5 (Driver, Ridley, Fisher, Hamill, Baker) through /30, /50, /99, /125,
// /184..215, and some unnumbered; TCDB corroborates (it tags Rena Owen
// SN199). CK's per-sub-set parallel model cannot express per-card base runs,
// so the base rows here are serial-less; the Gold /25 and Red 1/1 slots are
// the serialed paths. Do NOT add a single blank-name slot — there is no one
// run it could honestly display. Harrison Ford's base autograph is real but
// ultra-scarce (nslists has only plates documented; TCDB catalogs the card).
//
// DUAL AUTOGRAPHS: 9 cards, base serial runs vary per card — six at /50,
// DA-GC at /16, and the two marquee pairings (Fisher/Blakiston,
// McDiarmid/Carson) at /5 (nslists). The blank rule-6 slot is set at /50,
// the run six of nine cards carry; a collector holding one of the three
// short-run cards records the serial there (denominator displays /50 —
// documented trade-off, better than no serial path). No named parallels
// exist (TCDB lists none).
//
// TRIPLE AUTOGRAPHS: 8 cards, ALL /3 (nslists) — clean blank slot. SIX-PERSON
// AUTOGRAPH: one 1/1 (TCDB SN1), modeled like Stellar's quad.
//
// CK-ASSIGNED CODES (all four documented nowhere): every printed dual/triple
// code follows signer-surname initials (DA-BR Blakiston/Rose, TA-FBC
// Fisher/Barclay/Carter, ... — holds for all 13 documented codes), so the
// three unprinted-in-sources triples and one dual use the same derivation:
// DA-FB, TA-HBD, TA-MPB, TA-WGF. The six-person card is SPA-1 (CK-internal,
// finest-style). `n` is immutable — if a specimen ever shows different
// printed codes, note it in this header, never re-key.
//
// MEDALLIONS: 32 Vehicle Manufactured Medallions, VM- codes as printed (all
// three sources agree, including the odd VM-AP for Han Solo / AT-ST). Base
// unnumbered; Silver /99, Gold /25, Red Galactic 1/1 (TCDB names + SN tags,
// matching nslists' unnamed 99/25/1 columns).
//
// SKETCHES: 80 artists, alphabetical by surname (official PDF column order =
// TCDB's roster, name for name).
//
// NAME DISPUTES settled: "Graxol Kelvyyn" (official PDF + nslists over TCDB's
// "Kelvynn"), "Konstantine" (PDF + TCDB over nslists' "Kassius Konstantine"),
// voice credits kept as "(Voice)" in the character field (Revill, Bauersfeld).
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE — TEN FILM & SERIES SECTIONS",
    parallels: [
        { id: "orange", name: "Orange", print_run: null, color: "#ff9100" },
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 199, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "TPM-1", name: "Qui-Gon Jinn" },
        { n: "TPM-2", name: "Obi-Wan Kenobi" },
        { n: "TPM-3", name: "Queen Amidala" },
        { n: "TPM-4", name: "Darth Maul" },
        { n: "TPM-5", name: "Jar Jar Binks" },
        { n: "TPM-6", name: "Darth Sidious" },
        { n: "TPM-7", name: "R2-D2" },
        { n: "TPM-8", name: "C-3PO" },
        { n: "TPM-9", name: "Shmi Skywalker" },
        { n: "TPM-10", name: "Sio Bibble" },
        { n: "TPM-11", name: "Boss Nass" },
        { n: "TPM-12", name: "Watto" },
        { n: "TPM-13", name: "Captain Panaka" },
        { n: "TPM-14", name: "Nute Gunray" },
        { n: "TPM-15", name: "Rune Haako" },
        { n: "TPM-16", name: "Battle Droids" },
        { n: "TPM-17", name: "Sebulba" },
        { n: "TPM-18", name: "Chancellor Valorum" },
        { n: "TPM-19", name: "Ki-Adi-Mundi" },
        { n: "TPM-20", name: "Saesee Tiin" },
        { n: "TPM-21", name: "Plo Koon" },
        { n: "TPM-22", name: "Even Piell" },
        { n: "TPM-23", name: "Sabé" },
        { n: "TPM-24", name: "Ric Olié" },
        { n: "TPM-25", name: "Captain Tarpals" },
        { n: "AOTC-1", name: "Count Dooku" },
        { n: "AOTC-2", name: "Mace Windu" },
        { n: "AOTC-3", name: "Chancellor Palpatine" },
        { n: "AOTC-4", name: "Jango Fett" },
        { n: "AOTC-5", name: "Boba Fett" },
        { n: "AOTC-6", name: "Zam Wesell" },
        { n: "AOTC-7", name: "Bail Organa" },
        { n: "AOTC-8", name: "Sio Bibble" },
        { n: "AOTC-9", name: "Cliegg Lars" },
        { n: "AOTC-10", name: "Owen Lars" },
        { n: "AOTC-11", name: "Beru Whitesun" },
        { n: "AOTC-12", name: "Captain Typho" },
        { n: "AOTC-13", name: "Jocasta Nu" },
        { n: "AOTC-14", name: "Taun We" },
        { n: "AOTC-15", name: "Lama Su" },
        { n: "AOTC-16", name: "Dexter Jettster" },
        { n: "AOTC-17", name: "Kit Fisto" },
        { n: "AOTC-18", name: "Aayla Secura" },
        { n: "AOTC-19", name: "Poggle the Lesser" },
        { n: "AOTC-20", name: "Wat Tambor" },
        { n: "ACW-1", name: "Ahsoka Tano" },
        { n: "ACW-2", name: "Hondo Ohnaka" },
        { n: "ACW-3", name: "Darth Maul" },
        { n: "ACW-4", name: "Savage Opress" },
        { n: "ACW-5", name: "Mother Talzin" },
        { n: "ACW-6", name: "Asajj Ventress" },
        { n: "ACW-7", name: "Boba Fett" },
        { n: "ACW-8", name: "Satine Kryze" },
        { n: "ACW-9", name: "Captain Rex" },
        { n: "ACW-10", name: "Cad Bane" },
        { n: "ACW-11", name: "Ziro The Hutt" },
        { n: "ACW-12", name: "Mortis Father" },
        { n: "ACW-13", name: "Mortis Son" },
        { n: "ACW-14", name: "Mortis Daughter" },
        { n: "ACW-15", name: "Lux Bonteri" },
        { n: "ACW-16", name: "Embo" },
        { n: "ACW-17", name: "Rush Clovis" },
        { n: "ACW-18", name: "Bo-Katan Kryze" },
        { n: "ACW-19", name: "Pre Vizsla" },
        { n: "ACW-20", name: "Aurra Sing" },
        { n: "ACW-21", name: "Cato Parasitti" },
        { n: "ROTS-1", name: "Anakin Skywalker" },
        { n: "ROTS-2", name: "Supreme Chancellor Palpatine" },
        { n: "ROTS-3", name: "R2-D2" },
        { n: "ROTS-4", name: "C-3PO" },
        { n: "ROTS-5", name: "Yoda" },
        { n: "ROTS-6", name: "Padmé Amidala" },
        { n: "ROTS-7", name: "General Grievous" },
        { n: "ROTS-8", name: "Count Dooku" },
        { n: "ROTS-9", name: "Mace Windu" },
        { n: "ROTS-10", name: "Bail Organa" },
        { n: "ROTS-11", name: "Commander Cody" },
        { n: "ROTS-12", name: "Darth Sidious" },
        { n: "ROTS-13", name: "Chewbacca" },
        { n: "ROTS-14", name: "Tarfful" },
        { n: "ROTS-15", name: "Tion Medon" },
        { n: "ROTS-16", name: "Mas Amedda" },
        { n: "ROTS-17", name: "Stass Allie" },
        { n: "ROTS-18", name: "Captain Colton" },
        { n: "REB-1", name: "Kanan Jarrus" },
        { n: "REB-2", name: "Hera Syndulla" },
        { n: "REB-3", name: "Sabine Wren" },
        { n: "REB-4", name: "Zeb Orrelios" },
        { n: "REB-5", name: "Chopper" },
        { n: "REB-6", name: "Ezra Bridger" },
        { n: "REB-7", name: "The Grand Inquisitor" },
        { n: "REB-8", name: "Agent Kallus" },
        { n: "REB-9", name: "Maketh Tua" },
        { n: "REB-10", name: "Myles Grint" },
        { n: "REB-11", name: "Cikatro Vizago" },
        { n: "REB-12", name: "Cham Syndulla" },
        { n: "REB-13", name: "Fifth Brother" },
        { n: "REB-14", name: "Seventh Sister" },
        { n: "REB-15", name: "Darth Vader" },
        { n: "ANH-1", name: "R2-D2" },
        { n: "ANH-2", name: "C-3PO" },
        { n: "ANH-3", name: "Imperial Stormtroopers" },
        { n: "ANH-4", name: "Rebel Fleet Troopers" },
        { n: "ANH-5", name: "Princess Leia Organa" },
        { n: "ANH-6", name: "Darth Vader" },
        { n: "ANH-7", name: "Raymus Antilles" },
        { n: "ANH-8", name: "Jawas" },
        { n: "ANH-9", name: "R5-D4" },
        { n: "ANH-10", name: "Luke Skywalker" },
        { n: "ANH-11", name: "Owen Lars" },
        { n: "ANH-12", name: "Beru Lars" },
        { n: "ANH-13", name: "Obi-Wan Kenobi" },
        { n: "ANH-14", name: "Grand Moff Tarkin" },
        { n: "ANH-15", name: "Han Solo" },
        { n: "ANH-16", name: "Chewbacca" },
        { n: "ANH-17", name: "Ponda Baba" },
        { n: "ANH-18", name: "Dr. Evazan" },
        { n: "ANH-19", name: "Greedo" },
        { n: "ANH-20", name: "BoShek" },
        { n: "ANH-21", name: "Momaw Nadon" },
        { n: "ANH-22", name: "Admiral Motti" },
        { n: "ANH-23", name: "Wedge Antilles" },
        { n: "ANH-24", name: "Jek Porkins" },
        { n: "ANH-25", name: "Biggs Darklighter" },
        { n: "ANH-26", name: "Commander Praji" },
        { n: "ANH-27", name: "General Dodonna" },
        { n: "ANH-28", name: "Jon \"Dutch\" Vander" },
        { n: "ANH-29", name: "Davish \"Pops\" Krail" },
        { n: "ESB-1", name: "Boba Fett" },
        { n: "ESB-2", name: "Yoda" },
        { n: "ESB-3", name: "Lando Calrissian" },
        { n: "ESB-4", name: "Bossk" },
        { n: "ESB-5", name: "4-LOM" },
        { n: "ESB-6", name: "Zuckuss" },
        { n: "ESB-7", name: "IG-88" },
        { n: "ESB-8", name: "Dengar" },
        { n: "ESB-9", name: "Captain Piett" },
        { n: "ESB-10", name: "Admiral Ozzel" },
        { n: "ESB-11", name: "General Veers" },
        { n: "ESB-12", name: "Lobot" },
        { n: "ESB-13", name: "Wedge Antilles" },
        { n: "ESB-14", name: "Dak Ralter" },
        { n: "ESB-15", name: "Wampa" },
        { n: "ESB-16", name: "Ugnaughts" },
        { n: "ROTJ-1", name: "Jabba The Hutt" },
        { n: "ROTJ-2", name: "The Emperor" },
        { n: "ROTJ-3", name: "Wicket W. Warrick" },
        { n: "ROTJ-4", name: "Bib Fortuna" },
        { n: "ROTJ-5", name: "Oola" },
        { n: "ROTJ-6", name: "Moff Jerjerrod" },
        { n: "ROTJ-7", name: "Admiral Piett" },
        { n: "ROTJ-8", name: "Mon Mothma" },
        { n: "ROTJ-9", name: "General Madine" },
        { n: "ROTJ-10", name: "Gamorrean Guard" },
        { n: "ROTJ-11", name: "Malakili" },
        { n: "ROTJ-12", name: "Sy Snootles" },
        { n: "ROTJ-13", name: "Nien Nunb" },
        { n: "ROTJ-14", name: "Salacious B. Crumb" },
        { n: "ROTJ-15", name: "Tessek" },
        { n: "ROTJ-16", name: "Droopy McCool" },
        { n: "ROTJ-17", name: "Admiral Ackbar" },
        { n: "ROTJ-18", name: "Emperor's Royal Guard" },
        { n: "RO-1", name: "Jyn Erso" },
        { n: "RO-2", name: "Captain Cassian Andor" },
        { n: "RO-3", name: "Chirrut Îmwe" },
        { n: "RO-4", name: "Baze Malbus" },
        { n: "RO-5", name: "Bodhi Rook" },
        { n: "RO-6", name: "Director Krennic" },
        { n: "RO-7", name: "Saw Gerrera" },
        { n: "RO-8", name: "Galen Erso" },
        { n: "TFA-1", name: "Rey" },
        { n: "TFA-2", name: "Finn" },
        { n: "TFA-3", name: "Kylo Ren" },
        { n: "TFA-4", name: "BB-8" },
        { n: "TFA-5", name: "Captain Phasma" },
        { n: "TFA-6", name: "General Hux" },
        { n: "TFA-7", name: "Poe Dameron" },
        { n: "TFA-8", name: "Han Solo" },
        { n: "TFA-9", name: "General Leia Organa" },
        { n: "TFA-10", name: "Supreme Leader Snoke" },
        { n: "TFA-11", name: "Chewbacca" },
        { n: "TFA-12", name: "C-3PO" },
        { n: "TFA-13", name: "R2-D2" },
        { n: "TFA-14", name: "Maz Kanata" },
        { n: "TFA-15", name: "Unkar Plutt" },
        { n: "TFA-16", name: "Lor San Tekka" },
        { n: "TFA-17", name: "Tasu Leech" },
        { n: "TFA-18", name: "Bala-Tik" },
        { n: "TFA-19", name: "Razoo Qin-Fee" },
        { n: "TFA-20", name: "Snap Wexley" },
        { n: "TFA-21", name: "Major Ematt" },
        { n: "TFA-22", name: "Admiral Statura" },
        { n: "TFA-23", name: "Major Brance" },
        { n: "TFA-24", name: "Lieutenant Bastian" },
        { n: "TFA-25", name: "Jess \"Testor\" Pava" },
        { n: "TFA-26", name: "Ello Asty" },
        { n: "TFA-27", name: "Lieutenant Mitaka" },
        { n: "TFA-28", name: "Chief Petty Officer Unamo" },
        { n: "TFA-29", name: "First Order Riot Control Stormtrooper" },
        { n: "TFA-30", name: "Luke Skywalker" },
    ],
  },
  {
    id: "famous-quotes",
    type: "insert",
    title: "FAMOUS QUOTES",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "MQ-1", name: "Thank the Maker!", artist: "C-3PO" },
        { n: "MQ-2", name: "Do. Or do not. There is no try.", artist: "Yoda" },
        { n: "MQ-3", name: "Aren't you a little short for a stormtrooper?", artist: "Princess Leia" },
        { n: "MQ-4", name: "I find your lack of faith disturbing...", artist: "Darth Vader" },
        { n: "MQ-5", name: "It's a trap!", artist: "Admiral Ackbar" },
        { n: "MQ-6", name: "So this is how liberty dies... With thunderous applause.", artist: "Padmé Amidala" },
        { n: "MQ-7", name: "Never tell me the odds!", artist: "Han Solo" },
        { n: "MQ-8", name: "Hokey religions and ancient weapons are no match for a good blaster at your side.", artist: "Han Solo" },
        { n: "MQ-9", name: "He doesn't like you... I don't like you, either", artist: "Dr. Evazan" },
        { n: "MQ-10", name: "Use the force, Luke!", artist: "Ben (Obi-Wan) Kenobi" },
        { n: "MQ-11", name: "I suggest a new strategy, Artoo: Let the Wookiee win.", artist: "C-3PO" },
        { n: "MQ-12", name: "No. I am your father.", artist: "Darth Vader" },
        { n: "MQ-13", name: "Who's scruffy-looking?", artist: "Han Solo" },
        { n: "MQ-14", name: "Obi-Wan. Now that's a name I've not heard in a long time.", artist: "Ben (Obi-Wan) Kenobi" },
        { n: "MQ-15", name: "Help me, Obi-Wan Kenobi, you're my only hope.", artist: "Princess Leia" },
    ],
  },
  {
    id: "galactic-moments",
    type: "insert",
    title: "GALACTIC MOMENTS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "GM-1", name: "Death Star Destroys Alderaan" },
        { n: "GM-2", name: "Han Solo Rescued from Jabba's Palace" },
        { n: "GM-3", name: "Luke Meets Yoda" },
        { n: "GM-4", name: "Order 66" },
        { n: "GM-5", name: "Anakin Skywalker Wins Freedom" },
        { n: "GM-6", name: "Second Death Star Destroyed" },
        { n: "GM-7", name: "Skywalker Lightsaber Returned" },
        { n: "GM-8", name: "Vader Strikes Down Kenobi" },
        { n: "GM-9", name: "The Clone Wars Begin" },
    ],
  },
  {
    id: "locations",
    type: "insert",
    title: "LOCATIONS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "L-1", name: "Jabba the Hutt's Palace" },
        { n: "L-2", name: "Bespin" },
        { n: "L-3", name: "D'Qar" },
        { n: "L-4", name: "Yavin 4" },
        { n: "L-5", name: "Tarkintown" },
        { n: "L-6", name: "Otoh Gunga" },
        { n: "L-7", name: "Naboo" },
        { n: "L-8", name: "Level 1313" },
        { n: "L-9", name: "Jakku" },
        { n: "L-10", name: "Kashyyyk" },
    ],
  },
  {
    id: "vehicles",
    type: "insert",
    title: "VEHICLES",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "V-1", name: "Super Star Destroyer" },
        { n: "V-2", name: "Cloud Car" },
        { n: "V-3", name: "Jumpspeeder" },
        { n: "V-4", name: "X-34 Landspeeder" },
        { n: "V-5", name: "Yoda's Fighter" },
        { n: "V-6", name: "The Ghost" },
        { n: "V-7", name: "Tantive IV" },
        { n: "V-8", name: "Snowspeeder" },
        { n: "V-9", name: "Slave I" },
        { n: "V-10", name: "Podracer" },
        { n: "V-11", name: "Naboo Royal Starship" },
        { n: "V-12", name: "Death Star" },
        { n: "V-13", name: "Finalizer" },
        { n: "V-14", name: "Escape Pod" },
        { n: "V-15", name: "AT-ST Walker" },
        { n: "V-16", name: "A-wing Fighter" },
        { n: "V-17", name: "AT-AT" },
        { n: "V-18", name: "X-wing Starfighter" },
        { n: "V-19", name: "TIE Bomber" },
        { n: "V-20", name: "Imperial Shuttle" },
    ],
  },
  {
    id: "weapons",
    type: "insert",
    title: "WEAPONS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "W-1", name: "Anakin Skywalker's Lightsaber" },
        { n: "W-2", name: "Chewbacca's Bowcaster" },
        { n: "W-3", name: "DL-44 Blaster Pistol" },
        { n: "W-4", name: "E-11 Stormtrooper Rifle" },
        { n: "W-5", name: "Thermal Detonator" },
        { n: "W-6", name: "Gaderffii Stick" },
        { n: "W-7", name: "T-7 Ion Disruptor" },
        { n: "W-8", name: "Vibro-Ax" },
        { n: "W-9", name: "DLT-Heavy Blaster Rifle" },
        { n: "W-10", name: "Darth Vader's Lightsaber" },
    ],
  },
  {
    id: "autograph-cards",
    type: "auto",
    title: "AUTOGRAPHS",
    parallels: [
        { id: "gold", name: "Gold", print_run: 25, color: "#f0c040" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "AU-ADR", name: "Adam Driver", artist: "Kylo Ren" },
        { n: "AU-AWK", name: "Adrienne Wilkinson", artist: "Daughter" },
        { n: "AU-AT", name: "Alan Tudyk", artist: "K-2SO" },
        { n: "AU-ASC", name: "Andrew Secombe", artist: "Watto" },
        { n: "AU-ASK", name: "Andy Serkis", artist: "Supreme Leader Snoke" },
        { n: "AU-AGR", name: "Anna Graves", artist: "Duchess Satine Kryze" },
        { n: "AU-AND", name: "Anthony Daniels", artist: "C-3PO" },
        { n: "AU-AEK", name: "Ashley Eckstein", artist: "Ahsoka Tano" },
        { n: "AU-BBS", name: "Brian Blessed", artist: "Boss Nass" },
        { n: "AU-BSC", name: "Bruce Spence", artist: "Tion Medon" },
        { n: "AU-CFS", name: "Carrie Fisher", artist: "Princess Leia Organa" },
        { n: "AU-CTB", name: "Catherine Taber", artist: "Padmé Amidala" },
        { n: "AU-CRV", name: "Clive Revill", artist: "Emperor Palpatine (Voice)" },
        { n: "AU-DSR", name: "Daisy Ridley", artist: "Rey" },
        { n: "AU-DBK", name: "Dave Barclay", artist: "Jabba the Hutt" },
        { n: "AU-DBW", name: "David Bowers", artist: "Mas Amedda" },
        { n: "AU-DEB", name: "Dee Bradley Baker", artist: "Konstantine" },
        { n: "AU-DLS", name: "Denis Lawson", artist: "Wedge Antilles" },
        { n: "AU-DY", name: "Donnie Yen", artist: "Chirrut Îmwe" },
        { n: "AU-EBU", name: "Erik Bauersfeld", artist: "Admiral Ackbar (Voice)" },
        { n: "AU-FJ", name: "Felicity Jones", artist: "Jyn Erso" },
        { n: "AU-FW", name: "Forest Whitaker", artist: "Saw Gerrera" },
        { n: "AU-FPJ", name: "Freddie Prinze Jr.", artist: "Kanan Jarrus" },
        { n: "AU-GTK", name: "George Takei", artist: "Lok Durd" },
        { n: "AU-HRF", name: "Harrison Ford", artist: "Han Solo" },
        { n: "AU-HSP", name: "Hassani Shapi", artist: "Oppo Rancisis" },
        { n: "AU-JBU", name: "Jeremy Bulloch", artist: "Boba Fett" },
        { n: "AU-JBL", name: "Jerome Blake", artist: "Rune Haako" },
        { n: "AU-JJN", name: "Jesse Jensen", artist: "Saesee Tiin" },
        { n: "AU-JCM", name: "Jim Cummings", artist: "Hondo Ohnaka" },
        { n: "AU-JBY", name: "John Boyega", artist: "Finn" },
        { n: "AU-JCG", name: "John Coppinger", artist: "Graxol Kelvyyn" },
        { n: "AU-JGL", name: "Julian Glover", artist: "General Veers" },
        { n: "AU-KSO", name: "Kath Soucie", artist: "Mon Mothma" },
        { n: "AU-KBK", name: "Kenny Baker", artist: "R2-D2" },
        { n: "AU-KYG", name: "Keone Young", artist: "Jun Sato" },
        { n: "AU-LML", name: "Lewis MacLeod", artist: "Sebulba" },
        { n: "AU-LSR", name: "Lloyd Sherr", artist: "Father" },
        { n: "AU-MKH", name: "Mark Hamill", artist: "Luke Skywalker" },
        { n: "AU-MOY", name: "Mary Oyaya", artist: "Luminara Unduli" },
        { n: "AU-MUD", name: "Megan Udall", artist: "Melee" },
        { n: "AU-MC", name: "Michaela Cottrell", artist: "Even Piell" },
        { n: "AU-MCR", name: "Michael Carter", artist: "Bib Fortuna" },
        { n: "AU-MBG", name: "Michonne Bourriague", artist: "Aurra Sing" },
        { n: "AU-NFT", name: "Nika Futterman", artist: "Asajj Ventress" },
        { n: "AU-OFD", name: "Oliver Ford Davies", artist: "Sio Bibble" },
        { n: "AU-OWP", name: "Oliver Walpole", artist: "Seek" },
        { n: "AU-OD", name: "Olivia D'Abo", artist: "Luminara Unduli" },
        { n: "AU-PE", name: "Phil Eason", artist: "Yaddle" },
        { n: "AU-PLM", name: "Phil LaMarr", artist: "Bail Organa" },
        { n: "AU-RJB", name: "Rajia Baroudi", artist: "Miraj Scintel" },
        { n: "AU-RPK", name: "Ray Park", artist: "Darth Maul" },
        { n: "AU-ROW", name: "Rena Owen", artist: "Taun We" },
        { n: "AU-RA", name: "Riz Ahmed", artist: "Bodhi Rook" },
        { n: "AU-RNC", name: "Rohan Nichol", artist: "Captain Raymus Antilles" },
        { n: "AU-SWT", name: "Sam Witwer", artist: "Darth Maul" },
        { n: "AU-SCA", name: "Scott Capurro", artist: "Beed" },
        { n: "AU-SST", name: "Stephen Stanton", artist: "Mas Amedda" },
        { n: "AU-TKA", name: "Tom Kane", artist: "Yoda" },
        { n: "AU-TKY", name: "Tom Kenny", artist: "Nute Gunray" },
        { n: "AU-WPG", name: "Wayne Pygram", artist: "Wilhuff Tarkin" },
        { n: "AU-ZJN", name: "Zac Jensen", artist: "Kit Fisto" },
    ],
  },
  {
    id: "dual-autographs",
    type: "auto",
    title: "DUAL AUTOGRAPHS",
    parallels: [
        { id: "numbered", name: "", print_run: 50, color: "#c8d8f0" },
      ],
    cards: [
        { n: "DA-BR", name: "Caroline Blakiston / Tim Rose", artist: "Mon Mothma / Admiral Ackbar" },
        { n: "DA-FB", name: "Carrie Fisher / Caroline Blakiston", artist: "Leia Organa / Mon Mothma" },
        { n: "DA-TL", name: "Catherine Taber / Phil LaMarr", artist: "Padmé Amidala / Bail Organa" },
        { n: "DA-MC", name: "Ian McDiarmid / Silas Carson", artist: "Supreme Chancellor Palpatine / Nute Gunray" },
        { n: "DA-GC", name: "Julian Glover / Kenneth Colley", artist: "General Veers / Admiral Piett" },
        { n: "DA-NB", name: "Rohan Nichol / Ralph Brown", artist: "Captain Raymus Antilles / Ric Olié" },
        { n: "DA-CA", name: "Silas Carson / Amy Allen", artist: "Ki-Adi-Mundi / Aayla Secura" },
        { n: "DA-SK", name: "Stephen Stanton / Tom Kenny", artist: "Mas Amedda / Nute Gunray" },
        { n: "DA-GB", name: "Taylor Gray / Kath Soucie", artist: "Ezra Bridger / Mira Bridger" },
    ],
  },
  {
    id: "triple-autographs",
    type: "auto",
    title: "TRIPLE AUTOGRAPHS",
    parallels: [
        { id: "numbered", name: "", print_run: 3, color: "#c8d8f0" },
      ],
    cards: [
        { n: "TA-FBC", name: "Carrie Fisher / David Barclay / Michael Carter", artist: "Princess Leia / Jabba the Hutt / Bib Fortuna" },
        { n: "TA-RCG", name: "Clive Revill / Kenneth Colley / Julian Glover", artist: "Emperor Palpatine / Admiral Piett / General Veers" },
        { n: "TA-PGE", name: "Freddie Prinze Jr. / Taylor Gray / Ashley Eckstein", artist: "Kanan Jarrus / Ezra Bridger / Ahsoka Tano" },
        { n: "TA-GRR", name: "Greg Grunberg / Kipsang Rotich / Tim Rose", artist: "Snap Wexley / Nien Nunb (Voice) / Admiral Ackbar" },
        { n: "TA-MPB", name: "Ian McDiarmid / Ray Park / Jerome Blake", artist: "Darth Sidious / Darth Maul / Mas Amedda" },
        { n: "TA-HBD", name: "Mark Hamill / Kenny Baker / Anthony Daniels", artist: "Luke Skywalker / R2-D2 / C-3PO" },
        { n: "TA-WCB", name: "Matthew Wood / Silas Carson / Jerome Blake", artist: "General Grievous / Nute Gunray / Rune Haako" },
        { n: "TA-WGF", name: "Sam Witwer / Barbara Goodson / Nika Futterman", artist: "Darth Maul / Mother Talzin / Asajj Ventress" },
    ],
  },
  {
    id: "six-person-autograph",
    type: "auto",
    title: "SIX-PERSON AUTOGRAPH",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SPA-1", name: "Ian McDiarmid / Matthew Wood / Silas Carson / Wayne Pygram / Kenneth Colley / Julian Glover" },
    ],
  },
  {
    id: "vehicle-medallions",
    type: "insert",
    title: "VEHICLE MANUFACTURED MEDALLIONS",
    parallels: [
        { id: "silver", name: "Silver", print_run: 99, color: "#d4d4dc" },
        { id: "gold", name: "Gold", print_run: 25, color: "#f0c040" },
        { id: "red-galactic", name: "Red Galactic", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "VM-LS", name: "Luke Skywalker / Death Star" },
        { n: "VM-PL", name: "Princess Leia / Death Star" },
        { n: "VM-HS", name: "Han Solo / Death Star" },
        { n: "VM-OK", name: "Obi-Wan Kenobi / Death Star" },
        { n: "VM-GT", name: "Grand Moff Tarkin / Death Star" },
        { n: "VM-DV", name: "Darth Vader / Death Star" },
        { n: "VM-TE", name: "The Emperor / Death Star" },
        { n: "VM-JE", name: "Jyn Erso / Death Star" },
        { n: "VM-GE", name: "Galen Erso / Death Star" },
        { n: "VM-DK", name: "Director Krennic / Death Star" },
        { n: "VM-LK", name: "Luke Skywalker / AT-AT" },
        { n: "VM-DR", name: "Dak Ralter / AT-AT" },
        { n: "VM-GV", name: "General Veers / AT-AT" },
        { n: "VM-AT", name: "AT-AT Pilot / AT-AT" },
        { n: "VM-SW", name: "Snowtrooper / AT-AT" },
        { n: "VM-SM", name: "Stormtrooper / AT-AT" },
        { n: "VM-BF", name: "Boba Fett / Star Destroyer" },
        { n: "VM-BK", name: "Bossk / Star Destroyer" },
        { n: "VM-IG", name: "IG-88 / Star Destroyer" },
        { n: "VM-ZK", name: "Zuckuss / Star Destroyer" },
        { n: "VM-4L", name: "4-LOM / Star Destroyer" },
        { n: "VM-DG", name: "Dengar / Star Destroyer" },
        { n: "VM-JN", name: "Jyn Erso / U-Wing" },
        { n: "VM-CE", name: "Captain Cassian Andor / U-Wing" },
        { n: "VM-K2", name: "K-2SO / U-Wing" },
        { n: "VM-BZ", name: "Baze Malbus / U-Wing" },
        { n: "VM-CI", name: "Chirrut Îmwe / U-Wing" },
        { n: "VM-BT", name: "Bistan / U-Wing" },
        { n: "VM-AP", name: "Han Solo / AT-ST" },
        { n: "VM-CB", name: "Chewbacca / AT-ST" },
        { n: "VM-WW", name: "Wicket W. Warrick / AT-ST" },
        { n: "VM-SN", name: "Snowtrooper / AT-ST" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH ARTISTS",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Ben AbuSaada" },
        { n: "SK-2", name: "Jennifer Allyn" },
        { n: "SK-3", name: "Paul Andrews" },
        { n: "SK-4", name: "Kallan Archer" },
        { n: "SK-5", name: "Kyle Babbitt" },
        { n: "SK-6", name: "Mike Barnard" },
        { n: "SK-7", name: "Norvierto P. Basio" },
        { n: "SK-8", name: "Dan Bergren" },
        { n: "SK-9", name: "Brandon Blevins" },
        { n: "SK-10", name: "Joshua Bommer" },
        { n: "SK-11", name: "Carlos Cabaleiro" },
        { n: "SK-12", name: "Kate Carleton" },
        { n: "SK-13", name: "Jonathan Caustria" },
        { n: "SK-14", name: "Chris Clark" },
        { n: "SK-15", name: "Daniel Cooney" },
        { n: "SK-16", name: "Roy Cover" },
        { n: "SK-17", name: "Kaela Croft" },
        { n: "SK-18", name: "Pablo Diaz" },
        { n: "SK-19", name: "Louise Draper" },
        { n: "SK-20", name: "Dean Drummond" },
        { n: "SK-21", name: "Michael Duron" },
        { n: "SK-22", name: "Marcia Dye" },
        { n: "SK-23", name: "Brett Farr" },
        { n: "SK-24", name: "Andrew Fry" },
        { n: "SK-25", name: "Humberto Fuentes" },
        { n: "SK-26", name: "Bruce Gerlach" },
        { n: "SK-27", name: "Patrick Giles" },
        { n: "SK-28", name: "Kelly Greider" },
        { n: "SK-29", name: "Tiffany Groves" },
        { n: "SK-30", name: "Phil Hassewer" },
        { n: "SK-31", name: "Chris Henderson" },
        { n: "SK-32", name: "Jessica Hickman" },
        { n: "SK-33", name: "Kyle Hickman" },
        { n: "SK-34", name: "Scott Houseman" },
        { n: "SK-35", name: "Brad Hudson" },
        { n: "SK-36", name: "Alex Iniguez" },
        { n: "SK-37", name: "Brian Jackson" },
        { n: "SK-38", name: "Mike James" },
        { n: "SK-39", name: "Brian Kong" },
        { n: "SK-40", name: "Eric Lehtonen" },
        { n: "SK-41", name: "Kevin Liell" },
        { n: "SK-42", name: "Lak Lim" },
        { n: "SK-43", name: "Andrew Lopez" },
        { n: "SK-44", name: "Jordan Maison" },
        { n: "SK-45", name: "Matt Maldonado" },
        { n: "SK-46", name: "Jay Manchand" },
        { n: "SK-47", name: "Mark Mangum" },
        { n: "SK-48", name: "Shane McCormack" },
        { n: "SK-49", name: "Chris Meeks" },
        { n: "SK-50", name: "Jim Mehsling" },
        { n: "SK-51", name: "Jeff Meuth" },
        { n: "SK-52", name: "Solly Mohamed" },
        { n: "SK-53", name: "Veronica O'Connell" },
        { n: "SK-54", name: "Ibrahim Özkan" },
        { n: "SK-55", name: "Marsha Parkins" },
        { n: "SK-56", name: "Don Pedicini Jr." },
        { n: "SK-57", name: "Kris Penix" },
        { n: "SK-58", name: "Darrin Pepe" },
        { n: "SK-59", name: "J. P. Perez" },
        { n: "SK-60", name: "Eddie Price" },
        { n: "SK-61", name: "Matthew Pruno" },
        { n: "SK-62", name: "Brendan Purchase" },
        { n: "SK-63", name: "Michelle Rayner" },
        { n: "SK-64", name: "Cathy Razim" },
        { n: "SK-65", name: "Juan Rosales" },
        { n: "SK-66", name: "Stephanie Rosales" },
        { n: "SK-67", name: "Adam Schickling" },
        { n: "SK-68", name: "Anil Sharma" },
        { n: "SK-69", name: "Brendan Shaw" },
        { n: "SK-70", name: "Shaow Siong" },
        { n: "SK-71", name: "Anthony Skubis" },
        { n: "SK-72", name: "Tim Smith" },
        { n: "SK-73", name: "Tod Smith" },
        { n: "SK-74", name: "Jason Sobol" },
        { n: "SK-75", name: "Matt Steffens" },
        { n: "SK-76", name: "Matt Stewart" },
        { n: "SK-77", name: "Matthew Sutton" },
        { n: "SK-78", name: "Jamie Thomas" },
        { n: "SK-79", name: "Eric White" },
        { n: "SK-80", name: "Clinton Yeager" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
